import { createRoute } from '@tanstack/react-router';
import { rootRoute } from 'routes/rootRoute';

export const invalidTokenRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/498',
}).lazy(() => import('pages/shared/errors/Page498/Page498').then((d) => d.Route));
